import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import PortalFooter from "layouts/PortalFooter";
import PortalNavbar from "layouts/PortalNavbar";


function App() {

	const [isLoggedIn, setIsLoggedIn] = useState(false);
    
    const checkUserToken = () => {
        const userToken = localStorage.getItem('user-token');
        if (!userToken || userToken === 'undefined') {
            setIsLoggedIn(false);
        }
        setIsLoggedIn(true);
    }

    useEffect(() => {
        checkUserToken();
    }, [isLoggedIn]);
	
	return (
        
		<React.Fragment>
			{isLoggedIn && <PortalNavbar data={localStorage.getItem('user-data')} />}
			<Outlet />
			{isLoggedIn && <PortalFooter />}
		</React.Fragment>
	);
}

export default App;

